import { useMemo } from "react";

import { useAxios } from "@/lib/hooks";

import {
  assignKnowledgeBases,
  createAgent,
  createSettingsVersion,
  deleteAgent,
  getAgent,
  getAgentKnowledgeBases,
  getAgents,
  getSettingsVersion,
  listAgentLlmOptions,
  listSettingsVersions,
  removeKnowledgeBases,
  updateAgent,
} from "./agent";
import {
  AssignKnowledgeBasesInput,
  CreateAgentInput,
  CreateSettingsVersionInput,
  RemoveKnowledgeBasesInput,
  UpdateAgentInput,
} from "./types";

export const useAgentApi = () => {
  const { axiosInstance } = useAxios();

  return useMemo(
    () => ({
      createAgent: async (agent: CreateAgentInput) =>
        createAgent(agent, axiosInstance),
      getAgents: async () => getAgents(axiosInstance),
      getAgent: async (agentId: string) => getAgent(agentId, axiosInstance),
      updateAgent: async (agentId: string, agent: UpdateAgentInput) =>
        updateAgent(agentId, agent, axiosInstance),
      deleteAgent: async (agentId: string) =>
        deleteAgent(agentId, axiosInstance),
      getAgentKnowledgeBases: async (agentId: string) =>
        getAgentKnowledgeBases(agentId, axiosInstance),
      assignKnowledgeBases: async (
        agentId: string,
        data: AssignKnowledgeBasesInput,
      ) => assignKnowledgeBases(agentId, data, axiosInstance),
      removeKnowledgeBases: async (
        agentId: string,
        data: RemoveKnowledgeBasesInput,
      ) => removeKnowledgeBases(agentId, data, axiosInstance),
      listAgentLlmOptions: async () => listAgentLlmOptions(axiosInstance),
      listSettingsVersions: async (agentId: string) =>
        listSettingsVersions(agentId, axiosInstance),
      getSettingsVersion: async (agentId: string, versionId: string) =>
        getSettingsVersion(agentId, versionId, axiosInstance),
      createSettingsVersion: async (
        agentId: string,
        input: CreateSettingsVersionInput,
      ) => createSettingsVersion(agentId, input, axiosInstance),
    }),
    [axiosInstance],
  );
};
